export default __webpack_public_path__ + "static/media/shimla.64c32961.jpg";